import * as firebase from "firebase";


var firebaseConfig = {
    apiKey: "AIzaSyDneaZb-Jxa22J4tAK-mv9TODQS_7dgwKg",
    authDomain: "compile-labs.firebaseapp.com",
    databaseURL: "https://compile-labs.firebaseio.com",
    projectId: "compile-labs",
    storageBucket: "compile-labs.appspot.com",
    messagingSenderId: "375685624476",
    appId: "1:375685624476:web:f50da51e9e64c94922f359"
  };
  // Initialize Firebase
  var fireDb = firebase.initializeApp(firebaseConfig);

  export default fireDb.database().ref();